/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import EmptyView from "../../EmptyView";
import Icon from "../../ui/Icon";
import SearchSortBar from "../SearchSortBar";
import ProductGrid from "./ProductGrid";

const ProductsList = ({
  productsForSale, isLoading, selectedProducts,
  handleProductSelect, updateProduct,
  searchValue, sortBy,
  onSearchChange, onSortChange,
  hasNextPage, isFetchingNextPage, onLoadMore,
  canEditQty = true,
  addedLabel,
}) => {
  const products = productsForSale?.[0] ?? [];

  return <>
    <SearchSortBar searchValue={searchValue} sortBy={sortBy} onSearchChange={onSearchChange} onSortChange={onSortChange} />

    {!isLoading && !isFetchingNextPage && !products.length && (
      <EmptyView icon={Icon.BoxArchive} description="No products available" />
    )}

    <ProductGrid
      products={products}
      isLoading={isLoading || isFetchingNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      onLoadMore={onLoadMore}
      position={0}
      selectedProducts={selectedProducts}
      handleProductSelect={handleProductSelect}
      updateProduct={updateProduct}
      canEditQty={canEditQty}
      addedLabel={addedLabel}
    />
  </>;
};

export default ProductsList;